export default function FormFieldCheckbox({ formUtility, field, label, description, className, classNameControl, disabled = false }) {
    return (
        <div className={className ?? "form-group"} >
            {label?.toString()?.trim().length > 0 ? <label>{label.toString().trim()}</label> : null}
            <br />
            <input
                name={field}
                checked={formUtility.getFieldValue(field)}
                onChange={formUtility.handleChangeControl}
                readOnly={formUtility.fieldsDisabled || disabled}
                disabled={formUtility.fieldsDisabled || disabled}
                type="checkbox"
                className={classNameControl ?? "form-check-input"}            />
            {description?.toString()?.trim().length > 0 ? <p>{description.toString().trim()}</p> : <><br /><br /></>}
        </div>
    );
}